import { cn } from "@design-system/utils";
import * as React from "react";

import { Avatar } from "../avatar";

function SidebarHeaderWorkspace({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="sidebar-header-workspace"
      data-sidebar="header-workspace"
      className={cn("flex items-center gap-3", className)}
      {...props}
    />
  );
}

function SidebarHeaderWorkspaceLogo({
  className,
  ...props
}: React.ComponentProps<typeof Avatar>) {
  return (
    <Avatar
      data-slot="sidebar-header-workspace-logo"
      data-sidebar="header-workspace-logo"
      variant="company"
      className={cn("size-6", className)}
      {...props}
    />
  );
}

function SidebarHeaderWorkspaceTitle({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="sidebar-header-workspace-title"
      data-sidebar="header-workspace-title"
      className={cn(
        "flex-1 text-left text-sm leading-tight",
        "text-foreground-neutral-muted truncate font-normal",
        className
      )}
      {...props}
    />
  );
}

function SidebarHeaderWorkspaceActions({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="sidebar-header-workspace-actions"
      data-sidebar="header-workspace-actions"
      className={cn("flex items-center gap-1", className)}
      {...props}
    />
  );
}

export {
  SidebarHeaderWorkspace,
  SidebarHeaderWorkspaceActions,
  SidebarHeaderWorkspaceLogo,
  SidebarHeaderWorkspaceTitle,
};
